/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

/**
 * The PitchMotorBrakeGap component
 *
 * @author Thais Watanabe
 */
const PitchMotorBrakeGap = (props) => {
  const {
    turbineInspection,
    i8_7,
    i8_8,
    i8_9,
    r8_7,
    r8_8,
    r8_9,
    openObs,
    openEdit,
    lastInspection,
    isPastInspection,
    inspection,
    lastTurbineInspections,
  } = props;

  return (
    <Table>
      <thead>
        <tr>
          <ColHeader className="text-center" colSpan={19}>
            {isPastInspection
              ? lastInspection?.inspection?.name + "時測定結果"
              : "ピッチモータブレーキギャップ測定結果表"}
          </ColHeader>
        </tr>
        <tr>
          <ColHeader className="w-10 text-center print:hidden" rowSpan={2}></ColHeader>
          <ColHeader className="text-center" rowSpan={2}>
            軸
          </ColHeader>
          <ColHeader className="text-center" rowSpan={2}>
            測定箇所
          </ColHeader>
          <ColHeader className="text-center" colSpan={5}>
            初期
          </ColHeader>
          <ColHeader className="text-center" colSpan={2}>
            交換後
          </ColHeader>
        </tr>
        <tr>
          <ColHeader className="text-center">測定値</ColHeader>
          <ColHeader className="text-center">調整後の測定値</ColHeader>
          <ColHeader className="text-center">調整量</ColHeader>
          <ColHeader className="text-center">調整総量</ColHeader>
          <ColHeader className="text-center">ブレーキテスト</ColHeader>
          <ColHeader className="text-center">測定値</ColHeader>
          <ColHeader className="text-center">ブレーキテスト</ColHeader>
        </tr>
      </thead>
      <TableBody>
        {/* 8-7 */}
        <tr>
          <Col id="8-7" className="text-center print:hidden" rowSpan={6}>
            {!isPastInspection && (
              <ResultDropdown
                turbineInspection={turbineInspection}
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i8_7}
                selectedResult={r8_7}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
            )}
          </Col>
          <Col className="text-center" rowSpan={6}>
            1
          </Col>
          <Col className="text-center">No1</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[0] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[0].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[0] ?? "-", 0)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[6] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[6].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[6] ?? "-", 6)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[12] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[12].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[12] ?? "-", 12)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge
              result={r8_7?.childrenResults[18] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[18].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[18] ?? "-", 18)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge result={r8_7?.childrenResults[19] ?? "-"} />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[20] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[20].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[20] ?? "-", 20)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge result={r8_7?.childrenResults[26] ?? "-"} />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No2</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[1] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[1].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[1] ?? "-", 1)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[7] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[7].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[7] ?? "-", 7)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[13] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[13].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[13] ?? "-", 13)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[21] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[21].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[21] ?? "-", 21)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No3</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[2] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[2].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[2] ?? "-", 2)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[8] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[8].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[8] ?? "-", 8)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[14] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[14].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[14] ?? "-", 14)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[22] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[22].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[22] ?? "-", 22)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No4</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[3] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[3].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[3] ?? "-", 3)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[9] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[9].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[9] ?? "-", 9)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[15] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[15].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[15] ?? "-", 15)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[23] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[23].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[23] ?? "-", 23)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No5</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[4] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[4].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[4] ?? "-", 4)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[10] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[10].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[10] ?? "-", 10)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[16] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[16].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[16] ?? "-", 16)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[24] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[24].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[24] ?? "-", 24)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No6</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[5] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[5].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[5] ?? "-", 5)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[11] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[11].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[11] ?? "-", 11)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[17] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[17].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[17] ?? "-", 17)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_7?.childrenResults[25] ?? "-"}
              unit={i8_7?.inspectionModelItemChildren.items?.[25].unit}
              isInputCorrect={isInputCorrect("8-7", r8_7?.[25] ?? "-", 25)}
            />
          </Col>
        </tr>

        {/* 8-8 */}
        <tr>
          <Col id="8-8" className="text-center print:hidden" rowSpan={6}>
            {!isPastInspection && (
              <ResultDropdown
                turbineInspection={turbineInspection}
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i8_8}
                selectedResult={r8_8}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
            )}
          </Col>
          <Col className="text-center" rowSpan={6}>
            2
          </Col>
          <Col className="text-center">No1</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[0] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[0].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[0] ?? "-", 0)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[6] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[6].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[6] ?? "-", 6)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[12] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[12].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[12] ?? "-", 12)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge
              result={r8_8?.childrenResults[18] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[18].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[18] ?? "-", 18)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge result={r8_8?.childrenResults[19] ?? "-"} />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[20] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[20].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[20] ?? "-", 20)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge result={r8_8?.childrenResults[26] ?? "-"} />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No2</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[1] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[1].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[1] ?? "-", 1)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[7] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[7].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[7] ?? "-", 7)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[13] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[13].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[13] ?? "-", 13)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[21] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[21].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[21] ?? "-", 21)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No3</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[2] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[2].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[2] ?? "-", 2)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[8] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[8].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[8] ?? "-", 8)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[14] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[14].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[14] ?? "-", 14)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[22] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[22].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[22] ?? "-", 22)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No4</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[3] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[3].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[3] ?? "-", 3)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[9] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[9].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[9] ?? "-", 9)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[15] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[15].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[15] ?? "-", 15)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[23] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[23].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[23] ?? "-", 23)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No5</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[4] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[4].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[4] ?? "-", 4)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[10] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[10].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[10] ?? "-", 10)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[16] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[16].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[16] ?? "-", 16)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[24] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[24].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[24] ?? "-", 0)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No6</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[5] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[5].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[5] ?? "-", 5)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[11] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[11].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[11] ?? "-", 11)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[17] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[17].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[17] ?? "-", 17)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_8?.childrenResults[25] ?? "-"}
              unit={i8_8?.inspectionModelItemChildren.items?.[25].unit}
              isInputCorrect={isInputCorrect("8-8", r8_8?.[25] ?? "-", 25)}
            />
          </Col>
        </tr>

        {/* 8-9 */}
        <tr>
          <Col id="8-9" className="text-center print:hidden" rowSpan={6}>
            {!isPastInspection && (
              <ResultDropdown
                turbineInspection={turbineInspection}
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i8_9}
                selectedResult={r8_9}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
            )}
          </Col>
          <Col className="text-center" rowSpan={6}>
            3
          </Col>
          <Col className="text-center">No1</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[0] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[0].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[0] ?? "-", 0)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[6] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[6].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[6] ?? "-", 6)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[12] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[12].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[12] ?? "-", 12)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge
              result={r8_9?.childrenResults[18] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[18].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[18] ?? "-", 18)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge result={r8_9?.childrenResults[19] ?? "-"} />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[20] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[20].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[20] ?? "-", 20)}
            />
          </Col>
          <Col className="text-center" rowSpan={6}>
            <ResultBadge result={r8_9?.childrenResults[26] ?? "-"} />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No2</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[1] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[1].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[1] ?? "-", 1)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[7] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[7].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[7] ?? "-", 7)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[13] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[13].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[13] ?? "-", 13)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[21] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[21].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[21] ?? "-", 21)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No3</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[2] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[2].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[2] ?? "-", 2)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[8] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[8].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[8] ?? "-", 8)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[14] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[14].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[14] ?? "-", 14)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[22] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[22].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[22] ?? "-", 22)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No4</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[3] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[3].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[3] ?? "-", 3)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[9] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[9].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[9] ?? "-", 9)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[15] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[15].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[15] ?? "-", 15)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[23] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[23].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[23] ?? "-", 23)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No5</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[4] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[4].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[4] ?? "-", 4)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[10] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[10].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[10] ?? "-", 10)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[16] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[16].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[16] ?? "-", 16)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[24] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[24].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[24] ?? "-", 24)}
            />
          </Col>
        </tr>
        {/*  */}
        <tr>
          <Col className="text-center">No6</Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[5] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[5].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[5] ?? "-", 5)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[11] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[11].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[11] ?? "-", 11)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[17] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[17].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[17] ?? "-", 17)}
            />
          </Col>
          <Col className="text-center">
            <ResultBadge
              result={r8_9?.childrenResults[25] ?? "-"}
              unit={i8_9?.inspectionModelItemChildren.items?.[25].unit}
              isInputCorrect={isInputCorrect("8-9", r8_9?.[25] ?? "-", 25)}
            />
          </Col>
        </tr>
      </TableBody>
    </Table>
  );
};

export default PitchMotorBrakeGap;
